<template>
    <div class="
        fixed w:100vw h:calc(100dvh-92px) top:92 z:12 bg:white flex
        {h:calc(100dvh-41px);top:41}@<lg
        {w:952;mx:auto}_.inner-container
        {w:816}_.inner-container@<xl
        {w:690}_.inner-container@<lg
        {w:full;px:16;}_.inner-container@<sm
    " v-if="isShow">
        <div class="flex flex-direction:column flex:1">
            <page-space class="{pt:0}.no-marq@lg {pt:56}@lg"></page-space>
            <div class="h:68 bb:1|solid|#EBEBEB">
                <div class="inner-container">
                    <div class="flex jc:space-between ai:center h:68">
                        <button
                            class="inline-block w:44 h:44 r:12 bg:#EBEBEB bg:url(image/part/icon_delete.svg) background-repeat:no-repeat background-position:center|center {bg:url(image/part/icon_back.svg)}.topic"
                            :class="{ topic }"
                            @click="beforeClose"
                            type="button"
                        ></button>
                        <div class="flex gap:24 ai:center">
                            <button class="bg:primary color:white r:100 p:10|32 inline-flex h:44 px:32 {bg:#CECECE}:disabled" @click="submit" type="button" v-if="topic">
                                發佈
                            </button>
                            <button class="bg:primary color:white r:100 p:10|32 inline-flex h:44 px:32 {bg:#CECECE}:disabled" @click="preview" :disabled="empty" type="button" v-else-if="part">
                                預覽
                            </button>
                            <button class="bg:primary color:white r:100 p:10|32 inline-flex h:44 px:32 {bg:#CECECE}:disabled" @click="selectPart()" type="button" v-else>
                                下一步
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="topic">
                <div class="flex:1 py:48 overflow:auto">
                    <div class="inner-container">
                        <topic-preview :data="topic"></topic-preview>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="flex:1 py:48 overflow:auto">
                    <div class="inner-container">
                        <div class="flex gap:8 ai:flex-start">
                            <div class="flex rel cursor:pointer" @click="openNicknamePicker">
                                <member-avatar clickable :icon-url="userInfo.avatar_url" :size="48" :short-name="userInfo.short_name" :type="form.nickname_type"></member-avatar>
                                <div class="abs w:16 h:16 bottom:0 right:0 bg:url(image/part/posting-username-refresh.svg) background-position:0|0"></div>
                            </div>
                            <div class="flex:1">
                                <div class="h:48 flex ai:center w:full {f:20;font:bold;lh:1.4}>span">
                                    <topic-input autofocus editable :max-length="36" placeholder="趴趴趴，想說什麼？" single @submit="contentInput.focus()" v-model.trim="form.title"></topic-input>
                                </div>
                                <div>
                                    <topic-content class="mt:12" editable @loaded="refLoaded" placeholder="趴趴趴，有什麼新話題？" ref="contentInput" v-model="form.items"></topic-content>
                                    <div class="flex flex-wrap gap:16 mt-3">
                                        <span class="p:4|8 bg:#538BD41A r:8 flex gap:5 ai:center" :key="tag" v-for="(tag, idx) in form.tags">
                                            <span class="color:#538BD4" v-text="tag"></span>
                                            <button class="f:12 lh:1 inline-flex ai:center jc:center w:12 h:12" @click="removeTag(idx)">
                                                <i class="fa-solid fa-xmark"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h:68 box-shadow:0|0|10|0|#0000000D">
                    <div class="inner-container">
                        <div class="flex jc:space-between ai:center h:68">
                            <div class="flex gap:40 {w:28;h:28;inline-block;bg:no-repeat;background-potision:center|center}_.func-btn">
                                <button class="func-btn bg:url(image/part/posting-icon-image.svg)" @click="openImagePicker" type="button"></button>
                                <button class="func-btn bg:url(image/part/posting-icon-video.svg)" @click="openVideoPicker" type="button"></button>
                                <button class="func-btn bg:url(image/part/posting-icon-tag.svg)" @click="tagEditorModal.show()" type="button"></button>
                            </div>
                            <div class="flex gap:12 ai:center" v-if="part">
                                <button class="inline-flex gap:8 ai:center p:8|12" @click="selectPart(part.id)" type="button">
                                    <span>{{ part.title }}</span>
                                    <span class="inline-block w:18 h:18 bg:url(image/part/icon-target-forum.svg) bg:no-repeat background-potision:center|center" v-if="!id"></span>
                                </button>
                                <button class="p:8|12 r:8 b:1|solid|#CECECE" @click="showRule" type="button">
                                    趴規
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <input accept="image/*" @change="pickImage" class="hidden" multiple ref="imageInput" type="file" />
    <input accept="video/*" @change="pickVideo" class="hidden" ref="videoInput" type="file" />
    <part-picker ref="partPickerModal" @select="changePart"></part-picker>
    <part-rule ref="partRuleModal"></part-rule>
    <nickname-picker @change="changeNicknameType" ref="nicknamePickerModal"></nickname-picker>
    <topic-draft-picker ref="draftPickerModal"></topic-draft-picker>
    <topic-tag-editor ref="tagEditorModal" v-model="form.tags"></topic-tag-editor>
</template>

<script setup>
    const global = useGlobal();
    const userInfo = useUserInfo();

    const isShow = ref(false);
    const part = ref();
    const id = ref();
    const topic = ref();
    const form = ref({});

    const contentInput = ref();
    const draftPickerModal = ref();
    const imageInput = ref();
    const nicknamePickerModal = ref();
    const partPickerModal = ref();
    const partRuleModal = ref();
    const tagEditorModal = ref();
    const videoInput = ref();

    const empty = computed(() => {
        if (!form.value.title) {
            return true;
        }

        if (!form.value.items.filter((item) => item.type !== 1 || item.text.trim()).length) {
            return true;
        }

        return false;
    });

    const beforeClose = () => {
        if (topic.value) {
            topic.value = null;
        } else {
            // TODO: 須檢查是否變更
            global.showTopicEditor = false;
            unloadPreventer().off();
        }
    };

    const changeNicknameType = (newType) => {
        form.value.nickname_type = newType;
    };

    const changePart = (newPart) => {
        part.value = newPart;

        if (form.value.nickname_type === 6) {
            form.value.nickname_type = userInfo.type;
        }
    };

    const init = () => {
        id.value = null;
        form.value.nickname_type = userInfo.type;
        form.value.title = "";
        form.value.items = [{ text: "", type: 1 }];
        form.value.tags = [];
    };

    const open = () => {
        isShow.value = true;
        document.body.classList.add("overflow:hidden");
    };

    const openImagePicker = () => {
        imageInput.value.click();
    };

    const openNicknamePicker = () => {
        nicknamePickerModal.value.show(form.value.nickname_type, part.value);
    };

    const openVideoPicker = () => {
        videoInput.value.click();
    };

    const pickImage = () => {
        contentInput.value.addImages(imageInput.value.files);
        imageInput.value.value = "";
    };

    const pickVideo = () => {
        contentInput.value.addVideos(videoInput.value.files);
        videoInput.value.value = "";
    };

    const preview = () => {
        const data = {
            topic_id: id.value,
            part_id: part.value.id,
            nickname_type: form.value.nickname_type,
            title: form.value.title,
            content: form.value.items.filter((item) => item.type !== 1 || item.text),
            tags: form.value.tags
        };

        api("api/topic/preview", data).then((res) => {
            if (res.success) {
                topic.value = res.data;
            }
        });
    };

    const refLoaded = () => {
        setTimeout(() => unloadPreventer().off());
    };

    const removeTag = (index) => {
        form.value.tags.splice(index, 1);
    };

    const selectPart = (current) => {
        if (!id.value) {
            partPickerModal.value.show(current);
        }
    };

    const showRule = () => {
        if (part.value.rule) {
            partRuleModal.value.show(part.value);
        } else {
            api("api/part/get-rule", { part_id: part.value.id }).then((res) => {
                if (res.success) {
                    part.value.rule = res.data.rule;
                    partRuleModal.value.show(part.value);
                }
            });
        }
    };

    const submit = () => {
        api(`api/topic/${id.value ? "save" : "create"}`, { topic_token: topic.value.topic_token }).then((res) => {
            if (res.success) {
                unloadPreventer().off();

                if (id.value) {
                    window.location.reload();
                } else {
                    window.location.href = `part/${res.data.part_id}`;
                }
            }
        });
    };

    watch(contentInput, () => {
        if (contentInput.value && global.topicEditorInfo.ref) {
            contentInput.value.addRef(global.topicEditorInfo.ref);
        }
    });

    watch(() => global.showTopicEditor, async () => {
        if (global.showTopicEditor) {
            if (await userInfo.init()) {
                part.value = global.topicEditorInfo.part;
                if (global.topicEditorInfo.topic) {
                    id.value = global.topicEditorInfo.topic.id;
                    form.value.nickname_type = global.topicEditorInfo.topic.nickname_type;
                    form.value.title = global.topicEditorInfo.topic.title;
                    form.value.items = global.topicEditorInfo.topic.content;
                    form.value.tags = global.topicEditorInfo.topic.tags || [];
                } else {
                    init();
                }
                setTimeout(open);
            }
        } else {
            init();
            part.value = null;
            isShow.value = false;
            document.body.classList.remove("overflow:hidden");
        }
    });

    watch(form, () => {
        if (isShow.value) {
            unloadPreventer().on();
        }
    }, { deep: true });
</script>
